import React, { useEffect, useMemo, useState } from "react";
import { flattenCategories } from "../../utils/flattenCategories";
import { usePavilions } from "./hooks/usePavilions";
import { InputField, SelectField } from ".././FormFields";

export default function PavilionForm({ initialData, onSubmit }) {
  const { data: pavilions, loadPavilions } = usePavilions();

  const companyId = localStorage.getItem("company_id");

  const [form, setForm] = useState({
    title: "",
    parent_id: "",
  });

  useEffect(() => {
    if (companyId) {
      loadPavilions(companyId);
    }
  }, [companyId]);

  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.pavilion_name || initialData.title || "",
        parent_id: initialData.parent_id?._id || initialData.parent_id || "",
      });
    }
  }, [initialData]);

  const parentPavilions = useMemo(
    () => flattenCategories(pavilions || []),
    [pavilions]
  );

  const submit = (e) => {
    e.preventDefault();

    onSubmit({
      pavilion_name: form.title,
      company_id: companyId,
      parent_id: form.parent_id || null,
    });
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-3">
      <SelectField
        label="Parent Pavilion"
        name="parent_id"
        value={form.parent_id || ""}
        onChange={(e) => setForm({ ...form, parent_id: e.target.value })}
        options={(parentPavilions || []).map((item) => ({
          value: item._id,
          label: item.title,
        }))}
        placeholder="Search pavilion..."
        isSearchable={true}
      />
      {/* <div>
       
        <label className="mb-1 block text-sm font-medium">
          Parent Pavilion
        </label>
        <select
          className="w-full rounded border p-2"
          value={form.parent_id}
          onChange={(e) =>
            setForm({ ...form, parent_id: e.target.value })
          }
        >
          <option value="">Parent Pavilion (Optional)</option>
          {parentPavilions.map((p) => (
            <option key={p._id} value={p._id}>
              {p.title}
            </option>
          ))}
        </select>
      </div> */}
      <InputField
        label="Pavilion Title"
        name="title"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
        required
      />

      {/* <div>
        <label className="mb-1 block text-sm font-medium">
          Pavilion Title<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="Pavilion Title"
          value={form.title}
          onChange={(e) =>
            setForm({ ...form, title: e.target.value })
          }
          required
        />
      </div> */}
      <div className="mt-4 flex justify-end">
        <button className="btn-primary">
            {initialData ? "Update" : "Save"}
        </button>
      </div>
    </form>
  );
}
